class PreorderAcknowledgement {
  constructor() {
    this.init();
  }

  init() {
    this.productForms = document.querySelectorAll('variant-selects');
    
    this.productForms.forEach((form) => {
      const sectionId = form.getAttribute('data-section');
      if (!sectionId) return;

      this.sectionId = sectionId;
      this.preorderContainer = document.getElementById(`preorder-acknowledgement-${sectionId}`);
      this.preorderCheckbox = document.getElementById(`preorder-checkbox-${sectionId}`);
      this.preorderError = document.getElementById(`preorder-error-${sectionId}`);
      this.addToCartButton = document.querySelector(`#product-form-${sectionId} [name="add"]`);
      
      if (!this.preorderContainer || !this.preorderCheckbox) return;

      // Listen for variant changes
      form.addEventListener('change', this.onVariantChange.bind(this));
      
      // Listen for add to cart attempts
      if (this.addToCartButton) {
        this.addToCartButton.addEventListener('click', this.onAddToCart.bind(this));
      }
      
      // Listen for checkbox changes
      this.preorderCheckbox.addEventListener('change', this.onCheckboxChange.bind(this));
      
      // Check initial state
      this.checkPreorderStatus();
    });
  }

  onVariantChange(event) {
    // Small delay to ensure variant data is updated
    setTimeout(() => this.checkPreorderStatus(), 100);
  }

  checkPreorderStatus() {
    // Get selected variant data
    const selectedVariantData = document.querySelector('[data-selected-variant]');
    if (!selectedVariantData) return;

    let selectedVariant;
    try {
      selectedVariant = JSON.parse(selectedVariantData.textContent);
    } catch (e) {
      return;
    }

    // Check if variant is preorder
    const isPreorder = this.isVariantPreorder(selectedVariant);
    
    if (isPreorder) {
      this.showPreorderAcknowledgement();
    } else {
      this.hidePreorderAcknowledgement();
    }
  }

  isVariantPreorder(variant) {
    if (!variant) return false;

    // Check inventory settings
    const tracksInventory = variant.inventory_management === 'shopify';
    const isOutOfStock = variant.inventory_quantity <= 0;
    const continuesSelling = variant.inventory_policy === 'continue';

    return tracksInventory && isOutOfStock && continuesSelling;
  }

  showPreorderAcknowledgement() {
    if (!this.preorderContainer) return;
    
    this.preorderContainer.style.display = 'block';
    this.preorderCheckbox.required = true;
    
    // Disable add to cart if not checked
    if (this.addToCartButton && !this.preorderCheckbox.checked) {
      this.addToCartButton.setAttribute('disabled', 'disabled');
    }
  }

  hidePreorderAcknowledgement() {
    if (!this.preorderContainer) return;
    
    this.preorderContainer.style.display = 'none';
    this.preorderCheckbox.required = false;
    this.preorderCheckbox.checked = false;
    
    // Re-enable add to cart
    if (this.addToCartButton) {
      this.addToCartButton.removeAttribute('disabled');
    }
    
    // Hide error
    if (this.preorderError) {
      this.preorderError.style.display = 'none';
    }
  }

  onCheckboxChange(event) {
    if (!this.addToCartButton) return;
    
    if (event.target.checked) {
      this.addToCartButton.removeAttribute('disabled');
      if (this.preorderError) {
        this.preorderError.style.display = 'none';
      }
    } else {
      this.addToCartButton.setAttribute('disabled', 'disabled');
    }
  }

  onAddToCart(event) {
    // Check if preorder container is visible
    const isPreorderVisible = this.preorderContainer && 
                              this.preorderContainer.style.display !== 'none';
    
    if (isPreorderVisible && !this.preorderCheckbox.checked) {
      event.preventDefault();
      event.stopPropagation();
      
      // Show error message
      if (this.preorderError) {
        this.preorderError.style.display = 'block';
      }
      
      // Scroll to checkbox
      this.preorderContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
      
      // Focus checkbox
      this.preorderCheckbox.focus();
      
      return false;
    }
  }
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new PreorderAcknowledgement());
} else {
  new PreorderAcknowledgement();
}